import { webSocketActions } from '../../../actions/medichat/websocket/websocketActions';

const initialState = {
  isConnected: false,
  messages: [],
  error: null
};

const webSocketReducer = (state = initialState, action) => {
  switch (action.type) {
    case webSocketActions.CONNECT:
      // When WebSocket connects, store the WebSocket object and set 'connected' to true
      return {
        ...state,
        isConnected: true
      };

    case webSocketActions.DISCONNECT:
      // When WebSocket disconnects, clear the socket object and set 'connected' to false
      return {
        ...state,
        isConnected: false
      };

    case webSocketActions.RECEIVE_MESSAGE:
      // When a message is received, store the message in the state
      return {
        ...state,
        messages: [...state.messages, action.payload]
      };
    case webSocketActions.WEBSOCKET_ERROR:
      return {
        ...state,
        error: action.payload
      };

    default:
      return state;
  }
};

export default webSocketReducer;
